// Massachusetts ZIP code coordinates mapping
// This includes major ZIP codes in Massachusetts with their lat/lng coordinates

export const zipCodeCoordinates: { [key: string]: [number, number] } = {
  // Boston area (02xxx)
  "02108": [-71.0589, 42.3601], // Boston
  "02109": [-71.0545, 42.3663], // Boston
  "02110": [-71.0511, 42.3571], // Boston
  "02111": [-71.0589, 42.3501], // Boston
  "02112": [-71.0589, 42.3501], // Boston
  "02113": [-71.0556, 42.3659], // Boston
  "02114": [-71.0689, 42.3614], // Boston
  "02115": [-71.0952, 42.3422], // Boston
  "02116": [-71.0789, 42.3501], // Boston
  "02117": [-71.0589, 42.3401], // Boston
  "02118": [-71.0739, 42.3388], // Boston
  "02119": [-71.0852, 42.3229], // Boston
  "02120": [-71.0972, 42.3317], // Boston
  "02121": [-71.0852, 42.3070], // Boston
  "02122": [-71.0572, 42.2970], // Boston
  "02123": [-71.0589, 42.3401], // Boston
  "02124": [-71.0672, 42.2870], // Boston
  "02125": [-71.0589, 42.3151], // Boston
  "02126": [-71.0906, 42.2726], // Boston
  "02127": [-71.0389, 42.3376], // Boston
  "02128": [-71.0089, 42.3776], // Boston
  "02129": [-71.0689, 42.3776], // Boston
  "02130": [-71.1114, 42.3098], // Boston
  "02131": [-71.1214, 42.2848], // Boston
  "02132": [-71.1689, 42.2798], // Boston
  "02133": [-71.0589, 42.3601], // Boston
  "02134": [-71.1232, 42.3551], // Boston
  "02135": [-71.1565, 42.3484], // Boston
  "02136": [-71.1256, 42.2551], // Boston
  "02137": [-71.1156, 42.2401], // Boston
  "02138": [-71.1211, 42.3770], // Cambridge
  "02139": [-71.1097, 42.3647], // Cambridge
  "02140": [-71.0870, 42.3917], // Cambridge
  "02141": [-71.0811, 42.3701], // Cambridge
  "02142": [-71.0811, 42.3626], // Cambridge
  "02143": [-71.0989, 42.3826], // Somerville
  "02144": [-71.1222, 42.4018], // Somerville
  "02145": [-71.0922, 42.3918], // Somerville
  "02148": [-71.0450, 42.4406], // Malden
  "02149": [-71.0495, 42.3948], // Everett
  "02150": [-71.0328, 42.4084], // Chelsea
  "02151": [-71.0328, 42.3834], // Revere
  "02152": [-70.9928, 42.4084], // Winthrop
  "02153": [-71.0589, 42.3826], // Medford
  "02155": [-71.1056, 42.4176], // Medford
  "02156": [-71.1256, 42.4226], // West Medford
  "02163": [-71.1389, 42.3776], // Boston (Cambridge)
  "02169": [-71.0833, 42.3792], // Quincy
  "02170": [-71.0183, 42.2675], // Quincy
  "02171": [-71.0533, 42.2925], // Quincy
  "02176": [-71.0061, 42.4251], // Melrose
  "02180": [-71.1522, 42.4668], // Stoneham
  "02184": [-70.9478, 42.2501], // Braintree
  "02185": [-70.9578, 42.2151], // Braintree
  "02186": [-71.0022, 42.2076], // Milton
  "02187": [-71.0622, 42.2426], // Milton
  "02188": [-70.9411, 42.2218], // Weymouth
  "02189": [-70.9311, 42.2418], // Weymouth
  "02190": [-70.9511, 42.2118], // Weymouth
  "02191": [-70.9411, 42.1618], // Weymouth
  "02199": [-71.0822, 42.3468], // Boston

  // Other 02xxx ZIP codes
  "02018": [-71.2489, 42.1418], // Accord
  "02019": [-71.1822, 42.3918], // Bellingham
  "02021": [-71.0922, 42.1551], // Canton
  "02025": [-70.8922, 42.0851], // Cohasset
  "02026": [-71.1789, 42.2318], // Dedham
  "02027": [-71.1789, 42.2418], // Dedham
  "02030": [-71.1156, 42.1718], // Dover
  "02031": [-71.0022, 42.0518], // East Mansfield
  "02032": [-71.1789, 42.0818], // East Walpole
  "02035": [-71.2822, 42.1051], // Foxboro
  "02038": [-71.3156, 42.1618], // Franklin
  "02040": [-70.6689, 42.0851], // Greenbush
  "02041": [-70.7022, 42.1618], // Green Harbor
  "02043": [-70.8356, 42.0318], // Hingham
  "02044": [-70.8356, 42.0418], // Hingham
  "02045": [-70.7689, 42.0818], // Hull
  "02048": [-71.0356, 42.0951], // Mansfield
  "02050": [-70.7356, 42.0551], // Marshfield
  "02051": [-70.7356, 42.0651], // Marshfield Hills
  "02052": [-71.2489, 42.1718], // Medfield
  "02053": [-71.3156, 42.1418], // Medway
  "02054": [-71.3989, 42.1751], // Millis
  "02055": [-70.6689, 42.0451], // Minot
  "02056": [-71.3322, 42.1384], // Norfolk
  "02059": [-70.7022, 42.0251], // North Marshfield
  "02060": [-70.6689, 42.0151], // North Scituate
  "02061": [-70.7356, 41.9818], // Norwell
  "02062": [-71.2156, 42.1618], // Norwood
  "02065": [-70.6356, 42.0451], // Ocean Bluff
  "02066": [-70.7022, 41.9618], // Scituate
  "02067": [-71.1022, 42.1051], // Sharon
  "02070": [-71.1022, 42.0651], // Sheldonville
  "02071": [-71.0356, 42.0551], // South Walpole
  "02072": [-71.0689, 42.1251], // Stoughton
  "02081": [-71.1789, 42.1918], // Walpole
  "02090": [-71.2656, 42.2118], // Westwood
  "02093": [-71.3156, 42.0851], // Wrentham

  // Needham and surrounding areas
  "02492": [-71.2328, 42.2835], // Needham
  "02493": [-71.1628, 42.3235], // Weston
  "02494": [-71.2328, 42.2935], // Needham Heights
  "02495": [-71.2028, 42.2535], // Nonantum

  // Newton area
  "02458": [-71.1928, 42.3468], // Newton
  "02459": [-71.1928, 42.3218], // Newton Centre
  "02460": [-71.2089, 42.3247], // Newtonville
  "02461": [-71.2089, 42.3147], // Newton Highlands
  "02462": [-71.2189, 42.3347], // Newton Lower Falls
  "02464": [-71.2089, 42.3647], // Newton Upper Falls
  "02465": [-71.2289, 42.3147], // West Newton
  "02466": [-71.2189, 42.3547], // Auburndale
  "02467": [-71.1589, 42.3147], // Chestnut Hill
  "02468": [-71.2589, 42.3347], // Waban

  // Waltham area
  "02451": [-71.2356, 42.3765], // Waltham
  "02452": [-71.2356, 42.3865], // Waltham
  "02453": [-71.2356, 42.3665], // Waltham
  "02454": [-71.2356, 42.3965], // Waltham
  "02455": [-71.2356, 42.3565], // North Waltham

  // Watertown
  "02471": [-71.1828, 42.3709], // Watertown
  "02472": [-71.1828, 42.3609], // Watertown
  "02477": [-71.1828, 42.3809], // Watertown

  // Belmont
  "02478": [-71.1789, 42.3959], // Belmont
  "02479": [-71.1589, 42.3859], // Belmont

  // Arlington
  "02474": [-71.1556, 42.4176], // Arlington
  "02475": [-71.1556, 42.4076], // Arlington
  "02476": [-71.1556, 42.4276], // Arlington

  // Lexington
  "02420": [-71.2289, 42.4459], // Lexington
  "02421": [-71.2289, 42.4359], // Lexington

  // Additional 02xxx ZIP codes
  "02703": [-71.1550, 41.6362], // Attleboro
  "02712": [-71.2717, 41.8501], // Chartley
  "02760": [-71.0883, 41.7001], // North Attleboro
  "02761": [-71.0883, 41.7001], // North Attleboro
  "02762": [-71.2856, 41.8834], // Plainville
  "02763": [-71.1550, 41.6362], // Attleboro Falls
  "02764": [-71.0495, 41.5918], // North Dighton
  "02766": [-71.2495, 41.7584], // Norton
  "02767": [-71.1878, 41.8168], // Raynham
  "02768": [-71.1878, 41.8168], // Raynham Center
  "02769": [-71.1328, 41.7751], // Rehoboth
  "02780": [-71.0883, 41.6801], // Taunton
  "02783": [-71.0883, 41.6801], // Taunton
  "02802": [-71.4123, 41.8501], // Albion
  "02824": [-71.4123, 41.8501], // Berkley
  "02826": [-71.4123, 41.8501], // Glendale
  "02830": [-71.4123, 41.8501], // Harrisville
  "02838": [-71.4123, 41.8501], // Manville
  "02858": [-71.4123, 41.8501], // Oakland
  "02860": [-71.4123, 41.8501], // Pawtucket
  "02861": [-71.4123, 41.8501], // Pawtucket
  "02862": [-71.4123, 41.8501], // Pawtucket
  "02863": [-71.4123, 41.8501], // Central Falls
  "02864": [-71.4123, 41.8501], // Cumberland
  "02865": [-71.4123, 41.8501], // Lincoln
  "02876": [-71.4123, 41.8501], // Slatersville
  "02895": [-71.4123, 41.8501], // Woonsocket
  "02896": [-71.4123, 41.8501], // North Smithfield
  "02917": [-71.4123, 41.8501], // Smithfield

  // Worcester area (01xxx)
  "01432": [-71.5523, 42.5751], // Ayer
  "01434": [-71.5523, 42.5651], // Devens
  "01450": [-71.5189, 42.5418], // Groton
  "01451": [-71.4356, 42.5118], // Harvard
  "01460": [-71.6856, 42.5851], // Littleton
  "01464": [-71.6022, 42.5218], // Shirley
  "01467": [-71.4689, 42.4818], // Still River
  "01470": [-71.5523, 42.5451], // Groton
  "01471": [-71.5523, 42.5351], // Groton
  "01472": [-71.6689, 42.5751], // West Groton
  "01503": [-71.8689, 42.2651], // Auburn
  "01504": [-71.7356, 42.1918], // Blackstone
  "01505": [-71.9022, 42.1251], // Boylston
  "01510": [-71.9689, 42.1951], // Clinton
  "01519": [-71.6689, 42.1418], // Grafton
  "01523": [-71.9356, 42.2851], // Lancaster
  "01525": [-71.6689, 42.1018], // Linwood
  "01526": [-71.6689, 42.0918], // Manchaug
  "01527": [-71.7689, 42.1118], // Millbury
  "01529": [-71.6356, 42.0718], // Millville
  "01532": [-71.7022, 42.1451], // Northborough
  "01534": [-71.6356, 42.1218], // Northbridge
  "01536": [-71.6689, 42.1951], // North Grafton
  "01538": [-71.6022, 42.0851], // North Oxford
  "01540": [-71.6689, 42.0451], // Oxford
  "01545": [-71.7689, 42.2318], // Shrewsbury
  "01546": [-71.7689, 42.2418], // Shrewsbury
  "01560": [-71.6356, 42.1751], // South Grafton
  "01561": [-71.9356, 42.2451], // South Lancaster
  "01564": [-71.9689, 42.2651], // Sterling
  "01568": [-71.5689, 42.0651], // Upton
  "01569": [-71.5356, 42.0451], // Uxbridge
  "01580": [-71.7022, 42.1851], // Westborough
  "01581": [-71.7022, 42.1951], // Westborough
  "01582": [-71.7022, 42.1751], // Westborough
  "01583": [-71.9356, 42.2051], // West Boylston
  "01586": [-71.5689, 42.0851], // West Millbury
  "01588": [-71.5356, 42.0251], // Whitinsville
  "01590": [-71.6689, 42.0851], // Sutton

  // Worcester
  "01601": [-71.8022, 42.2626], // Worcester
  "01602": [-71.8022, 42.2726], // Worcester
  "01603": [-71.8022, 42.2526], // Worcester
  "01604": [-71.7722, 42.2426], // Worcester
  "01605": [-71.7822, 42.2926], // Worcester
  "01606": [-71.7922, 42.3026], // Worcester
  "01607": [-71.7922, 42.2326], // Worcester
  "01608": [-71.8022, 42.2626], // Worcester
  "01609": [-71.8222, 42.2926], // Worcester
  "01610": [-71.8122, 42.2526], // Worcester
  "01613": [-71.8022, 42.2626], // Worcester
  "01614": [-71.8022, 42.2626], // Worcester
  "01615": [-71.8022, 42.2626], // Worcester
  "01653": [-71.8022, 42.2626], // Worcester
  "01654": [-71.8022, 42.2626], // Worcester
  "01655": [-71.8022, 42.2626], // Worcester

  // Framingham area
  "01701": [-71.4162, 42.2793], // Framingham
  "01702": [-71.4362, 42.3093], // Framingham
  "01703": [-71.3962, 42.2993], // Framingham
  "01704": [-71.4062, 42.3193], // Framingham
  "01705": [-71.4262, 42.2893], // Framingham

  // Marlborough area
  "01718": [-71.5523, 42.3459], // Village of Nagog Woods
  "01719": [-71.4689, 42.4151], // Boxborough
  "01720": [-71.4522, 42.4884], // Acton
  "01721": [-71.3189, 42.2251], // Ashland
  "01730": [-71.6022, 42.5851], // Bedford
  "01731": [-71.5189, 42.4851], // Hanscom AFB
  "01740": [-71.6689, 42.4618], // Bolton
  "01741": [-71.5189, 42.4218], // Carlisle
  "01742": [-71.5022, 42.5118], // Concord
  "01745": [-71.3522, 42.2618], // Fayville
  "01746": [-71.3689, 42.2051], // Holliston
  "01747": [-71.3022, 42.1651], // Hopedale
  "01748": [-71.3689, 42.2351], // Hopkinton
  "01749": [-71.5522, 42.3851], // Hudson
  "01752": [-71.5522, 42.3459], // Marlborough
  "01754": [-71.4356, 42.4618], // Maynard
  "01756": [-71.2856, 42.1351], // Mendon
  "01757": [-71.3189, 42.1051], // Milford
  "01760": [-71.3022, 42.2751], // Natick
  "01770": [-71.2856, 42.2918], // Sherborn
  "01772": [-71.3522, 42.2451], // Southborough
  "01773": [-71.4689, 42.5018], // Lincoln
  "01775": [-71.5022, 42.3651], // Stow
  "01776": [-71.3856, 42.3651], // Sudbury
  "01778": [-71.3689, 42.3918], // Wayland
  "01784": [-71.3022, 42.2018], // Woodville

  // Lowell area
  "01801": [-71.1522, 42.4993], // Woburn
  "01803": [-71.1189, 42.5293], // Burlington
  "01805": [-71.1189, 42.5193], // Burlington
  "01806": [-71.0689, 42.5593], // Woburn
  "01807": [-71.0689, 42.5493], // Woburn
  "01808": [-71.0689, 42.5393], // Woburn
  "01810": [-71.4022, 42.6426], // Andover
  "01812": [-71.4022, 42.6326], // Andover
  "01813": [-71.0689, 42.5293], // Woburn
  "01815": [-71.0689, 42.5193], // Woburn
  "01821": [-71.2189, 42.5626], // Billerica
  "01822": [-71.2189, 42.5526], // Billerica
  "01824": [-71.3689, 42.6959], // Chelmsford
  "01826": [-71.4356, 42.7093], // Dracut
  "01827": [-71.5022, 42.7426], // Dunstable
  "01830": [-71.0022, 42.8093], // Haverhill
  "01831": [-71.0022, 42.7993], // Haverhill
  "01832": [-71.0022, 42.7893], // Haverhill
  "01833": [-70.8689, 42.8493], // Georgetown
  "01834": [-70.9356, 42.7759], // Groveland
  "01835": [-71.0022, 42.7793], // Haverhill
  "01840": [-70.8789, 42.7059], // Lawrence
  "01841": [-70.8789, 42.7159], // Lawrence
  "01842": [-70.8789, 42.6959], // Lawrence
  "01843": [-70.8789, 42.7259], // Lawrence
  "01844": [-70.9456, 42.6626], // Methuen
  "01845": [-71.0856, 42.6426], // North Andover
  "01850": [-71.3222, 42.6343], // Lowell
  "01851": [-71.3222, 42.6443], // Lowell
  "01852": [-71.3022, 42.6243], // Lowell
  "01853": [-71.3122, 42.6543], // Lowell
  "01854": [-71.3322, 42.6143], // Lowell

  // Other 01xxx ZIP codes
  "01862": [-71.2689, 42.5959], // North Billerica
  "01863": [-71.3689, 42.6626], // North Chelmsford
  "01864": [-71.1356, 42.5826], // North Reading
  "01865": [-71.2689, 42.5559], // Nutting Lake
  "01866": [-71.2189, 42.5026], // Pinehurst
  "01867": [-71.0856, 42.5626], // Reading
  "01876": [-71.2856, 42.6293], // Tewksbury
  "01879": [-71.3689, 42.5959], // Tyngsboro
  "01880": [-71.0022, 42.5293], // Wakefield
  "01885": [-70.9356, 42.6426], // West Boxford
  "01886": [-71.4022, 42.5626], // Westford
  "01887": [-71.1356, 42.4959], // Wilmington
  "01888": [-71.1356, 42.4859], // Woburn
  "01889": [-71.1022, 42.5459], // North Reading
  "01890": [-71.0522, 42.4959], // Winchester

  // North Shore area
  "01901": [-70.9022, 42.5226], // Lynn
  "01902": [-70.9022, 42.5126], // Lynn
  "01903": [-70.9022, 42.5026], // Lynn
  "01904": [-70.8822, 42.4926], // Lynn
  "01905": [-70.8922, 42.5326], // West Lynn
  "01906": [-70.8356, 42.5459], // Saugus
  "01907": [-70.8689, 42.4826], // Swampscott
  "01908": [-70.8356, 42.4626], // Nahant
  "01910": [-70.8022, 42.5226], // Lynn
  "01913": [-70.7689, 42.6393], // Amesbury
  "01915": [-70.8356, 42.5826], // Beverly
  "01921": [-70.8789, 42.6426], // Boxford
  "01922": [-70.8122, 42.6759], // Byfield
  "01923": [-70.8356, 42.6226], // Danvers
  "01929": [-70.9022, 42.5826], // Essex
  "01930": [-70.8456, 42.6426], // Gloucester
  "01931": [-70.8456, 42.6326], // Gloucester
  "01937": [-70.8356, 42.5626], // Hathorne
  "01938": [-70.8789, 42.7426], // Ipswich
  "01940": [-70.8356, 42.5426], // Lynnfield
  "01944": [-70.8456, 42.6026], // Manchester
  "01945": [-70.8356, 42.5226], // Marblehead
  "01949": [-70.8356, 42.6626], // Middleton
  "01950": [-70.7689, 42.7426], // Newburyport
  "01951": [-70.7689, 42.7326], // Newburyport
  "01952": [-70.7356, 42.7726], // Salisbury
  "01960": [-70.8356, 42.5726], // Peabody
  "01961": [-70.8356, 42.5626], // Peabody
  "01965": [-70.8356, 42.5526], // Pride's Crossing
  "01966": [-70.8456, 42.6226], // Rockport
  "01969": [-70.8789, 42.7126], // Rowley
  "01970": [-70.8356, 42.5026], // Salem
  "01971": [-70.8356, 42.5126], // Salem
  "01982": [-70.8356, 42.6826], // South Hamilton
  "01983": [-70.8356, 42.6426], // Topsfield
  "01984": [-70.8356, 42.6026], // Wenham
  "01985": [-70.8122, 42.7226], // West Newbury

  // Additional 5xxx ZIP codes (Vermont)
  "05501": [-72.5806, 44.1939], // Andover (VT)
  "05544": [-72.8123, 44.4339] // St. Albans (VT)
};
